import React, { useState } from 'react'
// import { IoMenuOutline, IoCloseOutline } from 'react-icons/io5'
import { useAuth } from '../../context/AuthContext'
import { deleteCookie } from '../../utils/api/cookies'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { BiLogOutCircle } from 'react-icons/bi'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const navigate = useNavigate()
  const { isLogin } = useAuth()

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const logOut = () => {
    deleteCookie('token')
    toast.success('Logged out successfully')
    navigate('/login')
  }

  const menuItems = [{ label: 'Login', href: '/login' }]

  return (
    <nav className='relative'>
      {/* Top Bar */}
      <div className='bg-cream shadow-md z-40 px-4 py-2.5 flex justify-between items-center'>
        <div className='flex items-center gap-2'>
          <img
            src='https://cdn-icons-png.flaticon.com/512/3135/3135715.png'
            alt='profile'
            className='w-10 h-10 rounded-full object-cover'
          />
          <div>
            <p className='text-sm font-medium text-brown'>Admin</p>
            <p className='text-xs text-gray-500'>Administrator</p>
          </div>
        </div>

        {/* Mobile Menu Toggle */}
        {/* <button
          onClick={toggleMenu}
          className='md:hidden z-50 relative text-brown'
        >
          {isOpen ? <IoCloseOutline size={24} /> : <IoMenuOutline size={24} />}
        </button> */}

        {/* Desktop Menu */}
        <div className='hidden md:flex space-x-4'>
          {!isLogin ? (
            <div>
              {menuItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className='text-brown hover:text-link transition-colors'
                >
                  {item.label}
                </a>
              ))}
            </div>
          ) : (
            <div className='flex bg-tan items-center text-white px-2 py-2 rounded-md uppercase gap-2'>
              <BiLogOutCircle size={20} />
              <button onClick={logOut} className='text-sm'>
                LOGOUT
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Sliding Menu */}
      {/* <div
        className={`
          fixed top-0 right-0 w-64 h-full bg-white shadow-lg
          transform transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : 'translate-x-full'}
          md:hidden z-40 pt-16
        `}
      >
        <div className='flex flex-col space-y-4 p-4'>
          {menuItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className='text-brown hover:bg-beige hover:text-link px-3 py-2 rounded-md transition-colors'
              onClick={toggleMenu}
            >
              {item.label}
            </a>
          ))}
        </div>
      </div> */}

      {/* Overlay */}
      {isOpen && (
        <div
          className='fixed inset-0 bg-black opacity-50 z-30 md:hidden'
          onClick={toggleMenu}
        />
      )}
    </nav>
  )
}

export default Navbar
